import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem('2look_cart');
    return saved ? JSON.parse(saved) : [];
  });

  // Save cart items to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('2look_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product) => {
    setCartItems(prev => {
      const productId = product.id || product.Product_ID;
      const isExist = prev.find(item => (item.id || item.Product_ID) === productId);
      
      if (isExist) {
        return prev.map(item => 
          (item.id || item.Product_ID) === productId
            ? { ...item, quantity: (item.quantity || 1) + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
    
    alert(`${product.title || product.Title || 'Product'} has been added to your Cart!`);
  };

  const removeFromCart = (productId) => {
    setCartItems(prev => prev.filter(item => (item.id || item.Product_ID) !== productId));
  };

  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart }}>
      {children}
    </CartContext.Provider>
  );
};